export default "__VITE_ASSET__C$GSUcbV__"